import React from 'react';
import DynamicHeader from 'components/dynamic_header/DynamicHeader';
import Styled from './style/PagePlaylistVideos.styled';
import { useFetchPlayList, useFetchReguaLogo, useHandleRedirectByParams } from './hooks';
import { ICardPlayListVideos } from './interfaces/ICardPlayListVideos';
import { IoIosPlayCircle } from 'react-icons/io';
import { BlueButton } from 'pages/intermediarias/criatividadeDetail/versions/components/sections/Material.styled';
import { YellowButton } from 'components/UI/Buttons';
import { useHistory, useParams } from 'react-router-dom';

const CardList: React.FC<ICardPlayListVideos> = ({ dados, index, setVideoSelected }) => {
    function getYouTubeThumbnail(): string {
        if (!dados.idVideo) return '';
        return `https://img.youtube.com/vi/${dados.idVideo}/sddefault.jpg`;
    }

    return (
        <Styled.Card.Content>
            <Styled.Card.Title>{`#${index} - ${dados.title}`}</Styled.Card.Title>
            {(dados?.description?.length ?? 0) > 0 && <Styled.Card.Description>{dados.description}</Styled.Card.Description>}
            <Styled.Card.Thumbnail onClick={() => setVideoSelected(dados)}>
                <Styled.Card.Img src={getYouTubeThumbnail()} />
                <Styled.Card.Overlay />
                <Styled.Card.Play>
                    <IoIosPlayCircle size={48} />
                </Styled.Card.Play>
            </Styled.Card.Thumbnail>
        </Styled.Card.Content>
    );
};

const PagePlaylistVideos = () => {
    const { playlist, isLoading, indexVideo, setVideoSelected } = useFetchPlayList();
    const { handleRedirect } = useHandleRedirectByParams();
    const { getReguaLogo } = useFetchReguaLogo();
    const params = useParams();
    const history = useHistory();

    const { id, video } = params as { id: string; video?: string };

    const handleBack = () => {
        history.push(handleRedirect());
    };

    const handleFisrtVideo = () => {
        if (playlist && playlist.length > 0) {
            setVideoSelected(playlist[0]);
        }
    };

    const handleNextVideo = (videoActive?: string) => {
        const navActiveVideo: boolean = !!videoActive;

        if (playlist && playlist.length > 0) {
            if (!videoActive) {
                videoActive = playlist.filter(v => v.idVideo === video)[0].idVideo;
            }

            const indexPlaylist = playlist.findIndex(videoPlay => videoPlay.idVideo === videoActive);

            history.push(`/playlist-videos/${id}/${!navActiveVideo ? playlist[indexPlaylist + 1].idVideo : videoActive}`);
            window.location.reload();
        }
    };

    if (isLoading) {
        return (
            <section style={{ paddingTop: '100px', display: 'flex', flexDirection: 'column', alignItems: 'center', minHeight: '60vh' }}>
                <DynamicHeader />
                <div style={{ marginTop: 60, textAlign: 'center' }}>
                    <div
                        className="loader"
                        style={{
                            margin: '0 auto 24px',
                            width: 48,
                            height: 48,
                            border: '6px solid #eee',
                            borderTop: '6px solid #007bff',
                            borderRadius: '50%',
                            animation: 'spin 1s linear infinite',
                        }}
                    />
                    <h2 style={{ color: '#007bff', fontWeight: 600 }}>Carregando vídeos...</h2>
                    <p>Aguarde enquanto buscamos os vídeos da playlist.</p>
                </div>
            </section>
        );
    }

    if (playlist === null) {
        return (
            <section style={{ paddingTop: '100px', display: 'flex', flexDirection: 'column', alignItems: 'center', minHeight: '60vh' }}>
                <DynamicHeader />
                <div style={{ marginTop: 60, textAlign: 'center' }}>
                    <h2 style={{ color: '#555', fontWeight: 600 }}>Nenhum vídeo disponível</h2>
                    <p>
                        Não encontramos vídeos para esta playlist.
                        <br />
                        Tente novamente mais tarde ou escolha outra playlist.
                    </p>
                </div>
            </section>
        );
    }

    if (playlist.length === 0) {
        return (
            <section style={{ paddingTop: '100px', display: 'flex', flexDirection: 'column', alignItems: 'center', minHeight: '60vh' }}>
                <DynamicHeader />
                <div style={{ marginTop: 60, textAlign: 'center' }}>
                    <h2 style={{ color: '#555', fontWeight: 600 }}>Playlist vazia</h2>
                    <p>Esta playlist não possui vídeos cadastrados.</p>
                </div>
            </section>
        );
    }

    if (video && playlist.every(v => v.idVideo !== video)) {
        return (
            <section style={{ paddingTop: '100px', display: 'flex', flexDirection: 'column', alignItems: 'center', minHeight: '60vh' }}>
                <DynamicHeader />
                <div style={{ marginTop: 60, textAlign: 'center' }}>
                    <h2 style={{ color: '#d9534f', fontWeight: 600 }}>Vídeo não encontrado</h2>
                    <p>
                        O vídeo solicitado não está presente nesta playlist.
                        <br />
                        Selecione outro vídeo para continuar.
                    </p>
                </div>
            </section>
        );
    }

    if (playlist.length > 0) {
        return (
            <section style={{ paddingTop: '100px' }}>
                <DynamicHeader />
                <Styled.Container>
                    <Styled.ViewVideoPrincipal>
                        <iframe
                            src={`https://www.youtube.com/embed/${video}?autoplay=0&mute=0`}
                            title={playlist[0].title}
                            frameBorder="0"
                            allowFullScreen
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            style={{ marginTop: '10px' }}
                        ></iframe>
                        <Styled.HeaderContent>
                            <h1>{playlist.filter(v => v.idVideo === video).map(v => v.title)}</h1>
                            <p>
                                {playlist.findIndex(v => v.idVideo === video) + 1} de {playlist.length ?? 0}
                            </p>
                        </Styled.HeaderContent>
                    </Styled.ViewVideoPrincipal>
                    <Styled.PlayListLateral>
                        {playlist.map((video, index) => (
                            <div key={index}>
                                <CardList dados={video} index={index + 1} setVideoSelected={() => handleNextVideo(video.idVideo)} />
                            </div>
                        ))}
                    </Styled.PlayListLateral>

                    <Styled.Footer>
                        <BlueButton
                            style={{ borderRadius: '4px', maxWidth: '200px', maxHeight: '48px', fontSize: '18px' }}
                            onClick={() => handleBack()}
                        >
                            {'Página inicial'}
                        </BlueButton>
                        {playlist.length > 1 && playlist.findIndex(v => v.idVideo === video) != playlist.length - 1 && (
                            <YellowButton
                                style={{ borderRadius: '4px', maxWidth: '200px', maxHeight: '48px', fontSize: '18px' }}
                                onClick={() => (indexVideo === playlist.length - 1 ? handleFisrtVideo() : handleNextVideo())}
                            >
                                {playlist.length > 1 && indexVideo === playlist.length - 1 ? 'Assistir do início' : 'Próximo vídeo'}
                            </YellowButton>
                        )}
                    </Styled.Footer>
                </Styled.Container>
            </section>
        );
    }

    return <></>;
};

export default PagePlaylistVideos;
